<app-header-sem-menu></app-header-sem-menu>
<app-breadcrumb (onLoading)="updateLoading($event)"></app-breadcrumb>
<app-sidebar [hidden]="isLoading" ></app-sidebar>
